import { Type } from "class-transformer";
import User from "@/models/User";
import Project from "@/models/Project";

export default class ProjectAccessRequest {
  public id: string;
  public project_id: number;
  public user_id: number;
  public originator_id: number;
  public approver_id: number | null = null;
  public role: string;
  public message: string | null = null;
  public status: "pending" | "approved" | "rejected" | "canceled" = "pending";
  @Type(() => Date)
  public requested_at: Date;
  @Type(() => Date)
  public decided_at: Date | null = null;
  @Type(() => Date)
  public created_at: Date;
  @Type(() => Date)
  public updated_at: Date;
  @Type(() => Date)
  public deleted_at: Date | null = null;

  @Type(() => User)
  public user?: User;

  @Type(() => Project)
  public project?: Project;

  @Type(() => User)
  public approver?: User | null = null;

  @Type(() => User)
  public originator?: User | null = null;
}
